import React from 'react'

const Loader = () => {
    return (
        <div className="progress-1" >
            <div className="indeterminate" />
        </div >
    )
}

export default Loader
